<!--
 * @Author: your name
 * @Date: 2021-05-14 11:48:58
 * @LastEditTime: 2021-05-20 09:40:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zhihui\roses-admin-vue\src\views\pages\home\flow-monitoring\flowMonitoring.vue
-->
<template>
  <div class="main-container">
    <!-- 查询栏 -->
    <div class="query-nav">
      <el-form ref="queryFormRef" :model="queryForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="dateTime" label="起止时间">
              <el-date-picker
                v-model="dateTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="dateTimeChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="deviceName" label="设备名称">
              <el-input v-model.trim="queryForm.deviceName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="orgName" label="所属机构">
              <el-input v-model.trim="queryForm.orgName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" style="margin-right: 6px" @click="handleSearch"
              >搜索</el-button
            >
            <el-button @click="handleReset">重置</el-button>
          </el-col>
          <el-col :span="6">
            <el-button
              type="success"
              :loading="exportBtnLoading"
              style="float: right;"
              @click="handleExportLog"
              >{{ exportBtn }}</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 表格区域 -->
    <div class="table">
      <el-table ref="tableRef" :data="tableList" v-loading="tableLoading" stripe border>
        <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          prop="deviceName"
          label="设备名称"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          prop="orgName"
          label="所属机构"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          prop="startTime"
          label="开始时间"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          prop="endTime"
          label="结束时间"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          prop="rateFlowMB"
          label="使用流量"
          align="center"
          :resizable="false"
        ></el-table-column>
      </el-table>
    </div>
    <!-- 分页区域 -->
    <div class="page">
      <el-pagination
        :total="total"
        :current-page="queryForm.pageNo"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 30, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import flowApi from 'api/home/FlowMonit.js';

export default {
  data() {
    return {
      total: 0,
      queryForm: {
        pageNo: 1,
        pageSize: 10,
        startTime: '',
        endTime: '',
        deviceName: '',
        orgName: ''
      },
      exportBtnLoading: false,
      exportBtn: '导出数据',
      dateTime: '',
      tableList: [],
      tableLoading: true
    };
  },
  created() {
    this.postList();
  },
  methods: {
    postList() {
      flowApi.postList(this.queryForm).then(res => {
        if (res.data.code === 200) {
          console.log(res);
          this.total = res.data.data.totalRows;
          this.tableList = res.data.data.rows;
        }
        this.tableLoading = false;
      });
    },
    // 搜索
    handleSearch() {
      this.queryForm.pageNo = 1;
      this.postList();
    },
    // 重置
    handleReset() {
      this.$refs.queryFormRef.resetFields();
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = 10;
      this.dateTime = '';
      this.queryForm.startTime = '';
      this.queryForm.endTime = '';
      this.postList();
    },
    handleExportLog() {
      this.exportBtnLoading = true;
      this.exportBtn = '导出中...';
      let obj = {
        orgName: this.queryForm.orgName,
        deviceName: this.queryForm.deviceName,
        startTime: this.queryForm.startTime,
        endTime: this.queryForm.endTime
      };
      flowApi
        .getExport(obj)
        .then(res => {
          console.log(res);
          let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
          let h = JSON.stringify(res.headers);
          let j = JSON.parse(h);
          let fileName = decodeURI(j['content-disposition'].split('attachment; filename=')[1]);
          fileName = fileName.replace(/\"/g, '');
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          // debugger;
          link.click();
          window.URL.revokeObjectURL(link.href);
          this.exportBtnLoading = false;
          this.exportBtn = '导出数据';
          this.$message({
            type: 'success',
            message: '导出数据成功'
          });
        })
        .catch(err => {
          this.exportBtnLoading = false;
          this.exportBtn = '导出数据';
        });
    },
    // 日期选择
    dateTimeChange(val) {
      console.log(val);
      if (val) {
        this.queryForm.startTime = val[0];
        this.queryForm.endTime = val[1];
      } else {
        this.queryForm.startTime = '';
        this.queryForm.endTime = '';
      }
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = val;
      this.postList();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      this.postList();
    }
  }
};
</script>
<style lang="less" scoped>
.main-container {
  padding: 16px;

  .page {
    margin: 16px 0;
    float: right;
  }
}
/deep/ .el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 100%;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
</style>
